import { useState } from "react";
import { Ac2AccessGroupModel } from "src/api/access/ac-group-types";
import { BaseButton } from "src/components";
import BaseSectionTitle from "src/components/layout/BaseSectionTitle";
import SelectAcGroupModal from "src/pages/product/forms/accessLevelForm/modals/SelectAcGroupModal";
import SpaceBaseTable from "src/pages/product/forms/commonSpaceForm/components/SpaceBaseTable";
import { acGroupColumns, addTypeDeleteCol } from "src/pages/visitor/components/acColumns";
import AllAccessDevicesModal from "src/pages/visitor/components/AllAccessDevicesModal";
import VisitorOnlyViewAccessGroup from "src/pages/visitor/components/VisitorOnlyViewAccessGroup";
import { useModal } from "src/recoil/modalState/hook";

type Props = {
  contractManageId: number;
  setAccessGroupIds: (ids: string[]) => void;
  visitorDefaultAccessGroupYn: boolean;
};

const WorkOrderAccessGroupSection = ({ contractManageId, setAccessGroupIds, visitorDefaultAccessGroupYn }: Props) => {
  const { setAbstractModalZ1 } = useModal();
  const [openAcModal, setOpenAcModal] = useState(false);
  // 방문자초대 출입그룹 목록
  const [selectAccessGroupList, setSelectAccessGroupList] = useState<Ac2AccessGroupModel[]>([]);

  // 출입그룹 추가 핸들러
  const handleAddAccessGroups = (selectedGroups: Ac2AccessGroupModel[]) => {
    // 이미 존재하는 그룹은 제외하고 새로운 그룹만 추가
    const newGroups = selectedGroups.filter((group) => !selectAccessGroupList.some((existingGroup) => existingGroup.id === group.id));
    const setData = [...selectAccessGroupList, ...newGroups];

    setSelectAccessGroupList(setData);
    setAccessGroupIds(setData.map((group) => group.id.toString()));
    // setSelectAccessGroupList((prev) => [...prev, ...newGroups]);
    setOpenAcModal(false);
  };

  // 출입그룹 삭제 핸들러
  const handleDeleteAccessGroup = (accessGroupId: number) => {
    const newAccessGroupIds = selectAccessGroupList.filter((group) => group.id !== accessGroupId);
    setSelectAccessGroupList(newAccessGroupIds);
    setAccessGroupIds(newAccessGroupIds.map((group) => String(group.id)));
  };
  return (
    <>
      {/* 기본권한일때 노출 */}
      {visitorDefaultAccessGroupYn === true && <VisitorOnlyViewAccessGroup pageType="add" contractManageId={contractManageId} />}

      {/* 커스텀권한일때 노출 */}
      {(contractManageId && visitorDefaultAccessGroupYn === false && (
        <article className="contents-container__wrap-article ">
          <div className="contents-container__sub-title mb0">
            <div className="flex-center-between w-100">
              <BaseSectionTitle title={"출입그룹"} className="pb0" noHashLink={true} />
              <div className="contents-container__grid-contents flex-center">
                <div className="flex-row gap10">
                  <BaseButton
                    title="장치목록 한번에 보기"
                    className="color-white"
                    onClick={() =>
                      setAbstractModalZ1({
                        size: "large",
                        isOpen: true,
                        children: <AllAccessDevicesModal accessGroupIds={selectAccessGroupList.map((group) => group.id).join(",")} />,
                      })
                    }
                  />
                  <BaseButton title="+ 출입그룹 추가" onClick={() => setOpenAcModal(true)} />
                </div>
              </div>
            </div>
            {openAcModal && (
              <SelectAcGroupModal
                setShowModal={setOpenAcModal}
                onSelectedAccessGroups={handleAddAccessGroups}
                existingAccess={selectAccessGroupList}
                visitorAccessYn={true}
                contractManageId={String(contractManageId)}
              />
            )}
          </div>
          <section>
            <SpaceBaseTable
              columns={[...acGroupColumns, ...addTypeDeleteCol]}
              data={selectAccessGroupList}
              handleDeleteAccessGroup={handleDeleteAccessGroup}
            />
          </section>
        </article>
      )) ||
        ""}
    </>
  );
};

export default WorkOrderAccessGroupSection;
